import { StarType } from '../../BenefitsRating';

export function getStarType({ index, rating }): StarType {
	if (index + 1 <= Math.floor(rating)) return 'full';
	if (index + 1 === Math.ceil(rating)) return 'half';
	return 'empty';
}
